import { Box } from "ui/box";
import { Stack } from "ui/stack";

import TruncatedText from "components/partials/truncated-text/truncated-text";
import { CommentDisplayByline } from "containers/admin/clients/touchpoint/components/comments/comment-display-by-line/comment-display-by-line";

import { formatDateTime } from "utilities/date";

import { CommentReply } from "types/comments";

export const CommentReplyDisplay = ({ reply }: { reply: CommentReply }) => {
  return (
    <Box data-testid="comment-reply-display">
      <CommentDisplayByline user={reply.user} />
      <Stack spacing={1} sx={{ fontSize: "0.75rem", ml: "1.5rem", letterSpacing: "0.025em" }}>
        <Box component="p">{formatDateTime(reply.createdDate)}</Box>
        <TruncatedText text={reply.text} noOfLines={4} initialTruncate={true} />
      </Stack>
    </Box>
  );
};
